
import {Component, Prop, Vue} from 'vue-property-decorator';
import {SportTypeVariant} from "@/modules/federation/services/SportTypeVariantService";
import {RefWithName} from "@/utils/Utils";

@Component
export default class SportTypeVariantBadge extends Vue {
  @Prop() public value!: SportTypeVariant | RefWithName;
}
